import * as i1$3 from '@angular/cdk/overlay';
import { OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, Pipe, EventEmitter, Output, InjectionToken, Injectable, Injector, Inject, ViewChild, HostBinding, HostListener, Directive, TemplateRef, ContentChild, ContentChildren, NgModule } from '@angular/core';
import * as i1$6 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2$3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatSliderModule } from '@angular/material/slider';
import * as i1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i1$1 from '@angular/platform-browser';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import * as i3$1 from '@firestitch/file';
import { FsFile, FsFileModule } from '@firestitch/file';
import * as i2$5 from '@firestitch/filter';
import { ActionMode, ActionType, FilterComponent, FsFilterModule } from '@firestitch/filter';
import * as i2$4 from '@firestitch/list';
import { FsListComponent, FsListModule } from '@firestitch/list';
import * as i1$5 from '@firestitch/menu';
import { FsMenuModule } from '@firestitch/menu';
import * as i7 from '@firestitch/pdf-viewer';
import { FsPdfViewerModule } from '@firestitch/pdf-viewer';
import * as i3 from 'ng2-dragula';
import { DragulaModule } from 'ng2-dragula';
import { FsApiFile } from '@firestitch/api';
import { of, Subject, BehaviorSubject, combineLatest } from 'rxjs';
import { map, takeUntil, debounceTime, take, switchMap, filter } from 'rxjs/operators';
import * as i2$1 from '@angular/router';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import * as i4 from '@angular/material/sidenav';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { guid, getNormalizedPath } from '@firestitch/common';
import { round } from 'lodash-es';
import * as i1$2 from '@firestitch/store';
import { FsPersistanceStore } from '@firestitch/store';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i1$4 from '@firestitch/label';
import { FsLabelModule } from '@firestitch/label';
import * as i2$2 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';

var MimeType;
(function (MimeType) {
    MimeType["Image"] = "image";
    MimeType["Video"] = "video";
    MimeType["Audio"] = "audio";
    MimeType["Application"] = "application";
    MimeType["Folder"] = "folder";
})(MimeType || (MimeType = {}));

var GalleryView;
(function (GalleryView) {
    GalleryView["Gallery"] = "gallery";
    GalleryView["List"] = "list";
})(GalleryView || (GalleryView = {}));

var GalleryLayout;
(function (GalleryLayout) {
    GalleryLayout["Grid"] = "grid";
    GalleryLayout["Flow"] = "flow";
    GalleryLayout["FlowNoWrap"] = "flow-nowrap";
})(GalleryLayout || (GalleryLayout = {}));

var ThumbnailScale;
(function (ThumbnailScale) {
    ThumbnailScale["Small"] = "small";
    ThumbnailScale["Medium"] = "medium";
    ThumbnailScale["Large"] = "large";
    ThumbnailScale["None"] = "none";
})(ThumbnailScale || (ThumbnailScale = {}));

var GalleryThumbnailSize;
(function (GalleryThumbnailSize) {
    GalleryThumbnailSize["Cover"] = "cover";
    GalleryThumbnailSize["Contain"] = "contain";
})(GalleryThumbnailSize || (GalleryThumbnailSize = {}));

class FsGalleryFolderIconInfoComponent {
    constructor() {
        this.item = null;
        this.MimeType = MimeType;
    }
    ngOnInit() {
        this.count = this.item.contains.files + this.item.contains.folders;
        if (this.count) {
            const parts = [];
            const images = this.item.contains.mimeTypes[MimeType.Image];
            if (images) {
                parts.push(`${images} ${(images === 1 ? 'image' : 'images')}`);
            }
            const videos = this.item.contains.mimeTypes[MimeType.Video];
            if (videos) {
                parts.push(`${videos} ${(videos === 1 ? 'video' : 'videos')}`);
            }
            const files = this.item.contains.files;
            if (files) {
                parts.push(`${files} ${(files === 1 ? 'file' : 'files')}`);
            }
            this.description = parts.join(' ,');
        }
        else {
            this.description = 'Empty Folder';
        }
    }
}
FsGalleryFolderIconInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryFolderIconInfoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsGalleryFolderIconInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryFolderIconInfoComponent, selector: "fs-gallery-folder-icon-info", inputs: { item: "item" }, ngImport: i0, template: "<span [matTooltip]=\"description\">{{count}}</span>", styles: ["span{position:absolute;right:6px;display:flex;bottom:6px;display:block;border-radius:50%;min-width:18px;text-align:center;font-size:10px;height:18px;line-height:18px;color:#fff;background:#888888}\n"], directives: [{ type: i1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryFolderIconInfoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-folder-icon-info',
                    templateUrl: './gallery-folder-icon-info.component.html',
                    styleUrls: ['./gallery-folder-icon-info.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { item: [{
                type: Input
            }] } });

class FsGalleryFileIconComponent {
    constructor() {
        this.width = 80;
        this.MimeType = MimeType;
    }
    ngOnChanges(changes) {
        if (changes.item) {
            this.color = this.item.mime.color || '#cccccc';
            this.darkColor = this.hue(this.color, -30);
        }
        if (changes.width && this.width) {
            this.fontSize = this.width * .2;
        }
        if (changes.height && this.height) {
            this.fontSize = this.height * .15;
        }
    }
    hue(hex, percent) {
        // strip the leading # if it's there
        hex = hex.replace(/^\s*#|\s*$/g, "");
        // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
        if (hex.length === 3) {
            hex = hex.replace(/(.)/g, "$1$1");
        }
        let r = parseInt(hex.substr(0, 2), 16);
        let g = parseInt(hex.substr(2, 2), 16);
        let b = parseInt(hex.substr(4, 2), 16);
        const calculatedPercent = (100 + percent) / 100;
        r = Math.round(Math.min(255, Math.max(0, r * calculatedPercent)));
        g = Math.round(Math.min(255, Math.max(0, g * calculatedPercent)));
        b = Math.round(Math.min(255, Math.max(0, b * calculatedPercent)));
        return `#${r.toString(16).toUpperCase()}${g.toString(16).toUpperCase()}${b
            .toString(16)
            .toUpperCase()}`;
    }
}
FsGalleryFileIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryFileIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsGalleryFileIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryFileIconComponent, selector: "fs-gallery-file-icon", inputs: { item: "item", width: "width", height: "height" }, usesOnChanges: true, ngImport: i0, template: "<div \n    class=\"file-icon\"\n    [style.height]=\"height ? height + 'px' : null\"\n    [style.width]=\"width ? width + 'px' : null\">\n  <ng-container *ngIf=\"item.folder\">\n    <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 270.7 309.6\" style=\"enable-background:new 0 0 270.7 309.6;\" xml:space=\"preserve\">\n      <style type=\"text/css\">\n        .st0{fill:#FFA000;}\n        .st1{fill:#FFCA28;}\n      </style>\n      <path class=\"st0\" d=\"M243.6,120.1H121.8L94.8,93H27.1C12.2,93,0,105.2,0,120.1v54.1h270.7v-27.1\n        C270.7,132.3,258.5,120.1,243.6,120.1z\"/>\n      <path class=\"st1\" d=\"M243.6,120.1H27.1C12.2,120.1,0,132.3,0,147.2v135.4c0,14.9,12.2,27.1,27.1,27.1h216.6\n        c14.9,0,27.1-12.2,27.1-27.1V147.2C270.7,132.3,258.5,120.1,243.6,120.1z\"/>\n    </svg>\n  \n    <fs-gallery-folder-icon-info\n      [item]=\"item\">\n    </fs-gallery-folder-icon-info>\n  </ng-container>\n  <ng-container *ngIf=\"!item.folder\">\n    <svg version=\"1.1\"xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 270.6 309.3\" style=\"enable-background:new 0 0 270.6 309.3;\" xml:space=\"preserve\">\n    <g>\n      <path [attr.fill]=\"color\" d=\"M19.3,0h164.2l87,86.7v203.2c0,10.7-8.7,19.3-19.3,19.3h-232C8.7,309.3,0,300.6,0,289.9V19.3C0,8.6,8.7,0,19.3,0z\"/>\n      <path [attr.fill]=\"darkColor\" d=\"M270.3,87H203c-10.7,0-19.3-8.7-19.3-19.3V0.2L270.3,87z\"/>\n    </g>\n    </svg>\n  </ng-container> \n\n  <div class=\"file-ext\" *ngIf=\"item.mime.extension\" [style.fontSize]=\"fontSize + 'px'\">\n    {{ item.mime.extension }}\n  </div>\n</div>\n", styles: [".file-icon{position:relative;margin:auto;-webkit-user-select:none;user-select:none}.file-icon svg{height:100%;display:block}.file-icon .file-ext{text-transform:uppercase;position:absolute;bottom:50%;left:50%;transform:translate(-50%) translateY(50%);color:#fff}\n"], components: [{ type: FsGalleryFolderIconInfoComponent, selector: "fs-gallery-folder-icon-info", inputs: ["item"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryFileIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-file-icon',
                    templateUrl: './gallery-file-icon.component.html',
                    styleUrls: ['./gallery-file-icon.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { item: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }] } });

class ImageSrcPipe {
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
    }
    transform(url, cssUrl = false) {
        if (url instanceof File) {
            url = new FsFile(url);
        }
        if (cssUrl) {
            if (url instanceof FsApiFile) {
                return url.base64
                    .pipe(map((base64) => (`url(${base64})`)));
            }
            else if (url instanceof FsFile) {
                return url.base64
                    .pipe(map((base64) => `url(${base64})`));
            }
            else {
                return of(`url(${url})`);
            }
        }
        else {
            if (url instanceof FsApiFile) {
                return url.safeBase64Url;
            }
            if (url instanceof FsFile) {
                return url.base64
                    .pipe(map((base64) => this._sanitizer.bypassSecurityTrustResourceUrl(base64)));
            }
            return of(url);
        }
    }
}
ImageSrcPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ImageSrcPipe, deps: [{ token: i1$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
ImageSrcPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ImageSrcPipe, name: "imageSrc" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ImageSrcPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'imageSrc'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.DomSanitizer }]; } });

class FsGalleryPreviewCarouselComponent {
    constructor(_el) {
        this._el = _el;
        this.activeItemChanged = new EventEmitter();
        this.MimeType = MimeType;
    }
    itemClick(item) {
        this.activeItem = item;
        this.activeItemChanged.emit(item);
    }
    loaded() {
        const el = this._el.nativeElement.querySelector('.active');
        el === null || el === void 0 ? void 0 : el.scrollIntoView({ block: 'center', inline: 'center' });
    }
}
FsGalleryPreviewCarouselComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewCarouselComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FsGalleryPreviewCarouselComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryPreviewCarouselComponent, selector: "fs-gallery-preview-carousel", inputs: { items: "items", activeItem: "activeItem" }, outputs: { activeItemChanged: "activeItemChanged" }, ngImport: i0, template: "<div class=\"fs-gallery-preview-carousel\">\n  <ng-container\n      *ngFor=\"let item of items; let index = index;\">\n    <a \n        (click)=\"itemClick(item)\"\n        [attr.data-index]=\"index\"\n        [ngClass]=\"{ active: activeItem.guid === item.guid }\">\n      <ng-container [ngSwitch]=\"item.mime.type\">\n        <ng-template [ngSwitchCase]=\"MimeType.Image\">\n          <ng-container *ngIf=\"(item.url | imageSrc | async) as image\">\n            <img [src]=\"image\" (load)=\"loaded()\">\n          </ng-container>\n        </ng-template>\n        <ng-template ngSwitchDefault>\n          <fs-gallery-file-icon \n            [height]=\"100\"\n            [width]=\"null\"\n            [item]=\"item\">\n          </fs-gallery-file-icon>\n        </ng-template>\n      </ng-container>\n    </a>\n  </ng-container>\n</div>", styles: [":host{display:flex;justify-content:center}.fs-gallery-preview-carousel{display:flex;flex-direction:row;white-space:nowrap;overflow-x:auto;-webkit-user-select:none;user-select:none}.fs-gallery-preview-carousel img{border-radius:3px;height:100px;display:block}.fs-gallery-preview-carousel a{border-radius:4px;border:2px solid transparent;margin:10px 10px 0}.fs-gallery-preview-carousel a.active{border-color:#fff}.fs-gallery-preview-carousel a+a{margin-left:0}\n"], components: [{ type: FsGalleryFileIconComponent, selector: "fs-gallery-file-icon", inputs: ["item", "width", "height"] }], directives: [{ type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgSwitchDefault, selector: "[ngSwitchDefault]" }], pipes: { "async": i2.AsyncPipe, "imageSrc": ImageSrcPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewCarouselComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-preview-carousel',
                    templateUrl: './gallery-preview-carousel.component.html',
                    styleUrls: ['./gallery-preview-carousel.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { items: [{
                type: Input
            }], activeItem: [{
                type: Input
            }], activeItemChanged: [{
                type: Output
            }] } });

class FsGalleryPreviewRef {
    constructor(_overlayRef) {
        this._overlayRef = _overlayRef;
        this.onClose = new Subject();
    }
    get overlayRef() {
        return this._overlayRef;
    }
    close() {
        this.onClose.next();
        this.onClose.complete();
        this._overlayRef.dispose();
    }
}

/** Injection token that can be used to access the data that was passed in to a preview component. */
const PREVIEW_DATA = new InjectionToken('fs.gallery-preview');

class GalleryConfig {
    constructor(data) {
        this.allow = 'image/*';
        this.toolbar = true;
        this.reorderable = false;
        this.reorderEnd = null;
        this.reorderStart = null;
        this.repeat = true;
        this.info = {
            icon: false,
            name: false,
            menu: null,
        };
        this.layout = GalleryLayout.Grid;
        this.showCarousel = true;
        this.persist = true;
        this.thumbnail = {
            scale: ThumbnailScale.Medium,
        };
        this.zoom = true;
        this.mode = GalleryView.Gallery;
        this.filterInit = (query) => { };
        this.filterChange = (query) => { };
        this._listColumns$ = new BehaviorSubject([]);
        this._updateActions$ = new Subject();
        this._viewMode$ = new BehaviorSubject(GalleryView.Gallery);
        this._upload$ = new Subject();
        this._thumbnailScale$ = new BehaviorSubject(ThumbnailScale.Small);
        this._initConfig(data);
    }
    get viewMode$() {
        return this._viewMode$.asObservable();
    }
    get updateActions$() {
        return this._updateActions$.asObservable();
    }
    get upload$() {
        return this._upload$.asObservable();
    }
    get thumbnailScale$() {
        return this._thumbnailScale$.asObservable();
    }
    get listColumns$() {
        return this._listColumns$;
    }
    get viewMode() {
        return this._viewMode$.getValue();
    }
    get thumbnailScale() {
        return this._thumbnailScale$.getValue();
    }
    get viewModeGallery() {
        return this.viewMode === GalleryView.Gallery;
    }
    get viewModeList() {
        return this.viewMode === GalleryView.List;
    }
    get _resizeActionIcon() {
        switch (this.thumbnailScale) {
            case ThumbnailScale.Small:
                return 'photo_size_select_small';
            case ThumbnailScale.Medium:
                return 'photo_size_select_large';
            case ThumbnailScale.Large:
                return 'image';
        }
    }
    get _viewModeActionIcon() {
        switch (this.viewMode) {
            case GalleryView.Gallery:
                return 'view_list';
            case GalleryView.List:
                return 'view_module';
        }
    }
    setThumbnailScale(size) {
        this._thumbnailScale$.next(size);
    }
    setViewMode(mode) {
        this._viewMode$.next(mode);
        this.setThumbnailScale(this.thumbnailScale);
    }
    setListColumns(columns) {
        this._listColumns$.next(columns);
    }
    _initConfig(data) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.reorderable = !!data.reorderEnd;
        this.showChangeSize = (_a = data.showChangeSize) !== null && _a !== void 0 ? _a : true;
        this.showChangeView = (_b = data.showChangeView) !== null && _b !== void 0 ? _b : true;
        this.reload = (_c = data.reload) !== null && _c !== void 0 ? _c : true;
        this.emptyState = data.emptyState;
        if (data.layout) {
            this.layout = data.layout;
        }
        this.repeat = (data.repeat !== undefined) ? data.repeat : true;
        this.showCarousel = (data.showCarousel !== undefined) ? data.showCarousel : true;
        if (data.zoom !== undefined) {
            this.zoom = data.zoom;
        }
        if (data.allow) {
            this.allow = data.allow;
        }
        if (data.persist !== undefined) {
            this.persist = data.persist;
        }
        if (data.thumbnail) {
            this.thumbnail = Object.assign(Object.assign({}, this.thumbnail), data.thumbnail);
            if (data.thumbnail.scale) {
                this.setThumbnailScale(data.thumbnail.scale);
            }
        }
        if (data.multiple !== undefined) {
            this.multiple = data.multiple;
        }
        if (data.details !== false) {
            this.details = Object.assign({ autoOpen: false }, data.details);
        }
        if (data.info !== false) {
            const info = data.info || {};
            this.info.icon = (_d = info.icon) !== null && _d !== void 0 ? _d : true;
            this.info.name = (_e = info.name) !== null && _e !== void 0 ? _e : true;
            this.info.menu = (_f = info.menu) !== null && _f !== void 0 ? _f : null;
        }
        this.reorderEnd = data.reorderEnd;
        this.reorderStart = data.reorderStart;
        this.map = data.map;
        this.selection = data.selection;
        this.previewClosed = data.previewClosed;
        this.previewOpened = data.previewOpened;
        this.previewBeforeOpen = data.previewBeforeOpen;
        this.zoomChanged = data.zoomChanged;
        this.noResults = data.noResults;
        this.fetch = data.fetch;
        this.upload = data.upload;
        this.actions = data.actions;
        this.previewActions = data.previewActions || [];
        this.previewMenu = data.previewMenu;
        this.preview = (_g = data.preview) !== null && _g !== void 0 ? _g : true;
        this.filterConfig = this._getFilterConfig(data.filters);
    }
    _getFilterConfig(items) {
        items = items && Array.isArray(items) ? items : [];
        const config = {
            init: (query) => {
                this.filterInit(query);
            },
            change: (query) => {
                this.filterChange(query);
            },
            items: [...items],
        };
        config.actions = this._getActionsConfig(this.actions);
        return config;
    }
    _toggleViewMode() {
        if (this.viewMode === GalleryView.Gallery) {
            this.setViewMode(GalleryView.List);
        }
        else {
            this.setViewMode(GalleryView.Gallery);
        }
    }
    _getActionsConfig(actions) {
        actions = actions && Array.isArray(actions) ? actions : [];
        const filterActions = [];
        if (this.showChangeSize) {
            filterActions.push({
                mode: ActionMode.Menu,
                icon: this._resizeActionIcon,
                type: ActionType.Raised,
                className: 'size',
                primary: false,
                items: [
                    {
                        label: 'Large',
                        icon: 'image',
                        click: () => {
                            this.setThumbnailScale(ThumbnailScale.Large);
                            this._updateActions();
                        },
                    },
                    {
                        label: 'Medium',
                        icon: 'photo_size_select_large',
                        click: () => {
                            this.setThumbnailScale(ThumbnailScale.Medium);
                            this._updateActions();
                        },
                    },
                    {
                        label: 'Small',
                        icon: 'photo_size_select_small',
                        click: () => {
                            this.setThumbnailScale(ThumbnailScale.Small);
                            this._updateActions();
                        },
                    },
                ],
            });
        }
        if (this.showChangeView) {
            filterActions.push({
                mode: ActionMode.Button,
                icon: this._viewModeActionIcon,
                className: 'view-mode',
                primary: false,
                click: () => {
                    this._toggleViewMode();
                    this._updateActions();
                },
            });
        }
        filterActions.push(...actions);
        if (this.upload) {
            filterActions.push(Object.assign(Object.assign({ mode: ActionMode.File, label: 'Upload', className: 'fs-gallery-upload-btn', color: 'primary', accept: this.allow, multiple: this.multiple }, this.upload), { select: (file) => {
                    this.upload.select(file)
                        .subscribe(() => {
                        this._upload$.next();
                    });
                } }));
        }
        return filterActions;
    }
    _updateActions() {
        this._updateActions$.next(this._getActionsConfig(this.actions));
    }
}

const FILTER_STORE_KEY = 'fs-gallery-persist';
class PersistanceController extends FsPersistanceStore {
    constructor(_store, _route) {
        super(_store, _route);
        this.STORE_KEY = FILTER_STORE_KEY;
    }
}
PersistanceController.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PersistanceController, deps: [{ token: i1$2.FsStore }, { token: i2$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Injectable });
PersistanceController.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PersistanceController });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PersistanceController, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.FsStore }, { type: i2$1.ActivatedRoute }]; } });

function mimeColor(extension, folder) {
    extension = String(extension);
    switch (extension) {
        case 'pdf':
            return '#D94A53';
        case 'doc':
        case 'docx':
            return '#3097D9';
        case 'xls':
        case 'xlsx':
            return '#6AAA47';
        default:
            if (folder) {
                return '#FFCA28';
            }
            else if (extension.match(/(jpe?g|png|gif|tiff?|bmp)/i)) {
                return '#a9c51c';
            }
            else if (extension.match(/(mov|avi|wmv|flv|3gp|mp4|mpg|mp3)/i)) {
                return '#A459AE';
            }
    }
    return null;
}

function mime(name, url, extension, folder) {
    if (!extension) {
        if (url instanceof File) {
            url = new FsFile(url);
        }
        if (url instanceof FsFile) {
            extension = url.extension;
        }
        if (typeof url === 'string') {
            const urlMatch = String(url).match(/\.([^\.]{3,4})(?=\?|$)/);
            if (urlMatch) {
                extension = urlMatch[1];
            }
        }
        else if (url instanceof FsApiFile) {
            const urlMatch = String(url.name).match(/\.([^\.]{3,4})(?=\?|$)/);
            if (urlMatch) {
                extension = urlMatch[1];
            }
        }
    }
    if (!extension) {
        const nameMatch = String(name).match(/\.([^\.]{3,4})$/);
        if (nameMatch) {
            extension = nameMatch[1];
        }
    }
    let type = null;
    if (extension) {
        if (extension.match(/(jpe?g|png|gif|tiff?|bmp)/i)) {
            type = MimeType.Image;
        }
        else if (extension.match(/(mov|avi|wmv|flv|3gp|mp4|mpg)/i)) {
            type = MimeType.Video;
        }
        else if (extension.match(/(mp3)/i)) {
            type = MimeType.Audio;
        }
        else {
            type = MimeType.Application;
        }
    }
    const color = mimeColor(extension, folder);
    return { type, extension, color };
}

function processMenuItems(menuItems, galleryItem) {
    return menuItems
        .filter((item) => {
        return !item.show || item.show(galleryItem);
    })
        .map((action) => {
        const label = action.label instanceof Function ?
            action.label(galleryItem) : action.label;
        return Object.assign(Object.assign({}, action), { label });
    });
}

const GalleryPreviewComponentInjector = new InjectionToken('FsGalleryPreviewComponent');

class FsGalleryPreviewService {
    constructor(_overlay, _galleryPreviewComponent, _injector, _galleryService = null) {
        this._overlay = _overlay;
        this._galleryPreviewComponent = _galleryPreviewComponent;
        this._injector = _injector;
        this._galleryService = _galleryService;
        this._destroy$ = new Subject();
        this._router = this._injector.get(Router);
        this._route = this._injector.get(ActivatedRoute);
    }
    open(data) {
        const overlayRef = this._createOverlay();
        this._previewRef = new FsGalleryPreviewRef(overlayRef);
        this._openPortalPreview(this._injector, overlayRef, this._previewRef, data);
        this._router.navigate([], {
            relativeTo: this._route,
            queryParams: { galleryPreview: true },
            queryParamsHandling: 'merge',
        }).then();
        this._previewRef.onClose
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            this._previewRef = null;
        });
        return this._previewRef;
    }
    close() {
        var _a;
        (_a = this._previewRef) === null || _a === void 0 ? void 0 : _a.close();
    }
    destroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    _createOverlay() {
        const overlayConfig = new OverlayConfig({
            height: '100%',
            width: '100%'
        });
        const overlayRef = this._overlay.create(overlayConfig);
        overlayRef.detachments()
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            this._router.navigate([], {
                relativeTo: this._route,
                queryParams: { galleryPreview: null },
                queryParamsHandling: 'merge',
            }).then(() => { });
        });
        return overlayRef;
    }
    _openPortalPreview(parentInjector, overlayRef, previewRef, data) {
        const injector = this._createInjector(parentInjector, previewRef, data);
        const containerPortal = new ComponentPortal(this._galleryPreviewComponent, undefined, injector);
        const containerRef = overlayRef.attach(containerPortal);
        setTimeout(() => {
            const overlayContainer = overlayRef.overlayElement.parentNode;
            overlayContainer.parentNode.append(overlayContainer);
        });
        return containerRef.instance;
    }
    _createInjector(parentInjector, previewRef, data) {
        const providers = [
            { provide: FsGalleryPreviewRef, useValue: previewRef },
            { provide: PREVIEW_DATA, useValue: data }
        ];
        if (this._galleryService) {
            providers.push({ provide: FsGalleryService, useValue: this._galleryService });
        }
        return Injector.create({
            parent: parentInjector,
            providers
        });
    }
}

class FsGalleryService {
    constructor(_galleryPreviewComponent, _overlay, _injector, _location, _dragulaService, _persistanceController) {
        this._galleryPreviewComponent = _galleryPreviewComponent;
        this._overlay = _overlay;
        this._injector = _injector;
        this._location = _location;
        this._dragulaService = _dragulaService;
        this._persistanceController = _persistanceController;
        this.dragName = 'fs-gallery-dragular';
        this.imageZoom = 0;
        this.imageZoomInteger = 0;
        this.dimentionsChange$ = new Subject();
        this.navItems = [];
        this.emptyStateEnabled = false;
        this.filtersReady$ = new Subject();
        this._fetch$ = new Subject();
        this._activeFilters$ = new BehaviorSubject(0);
        this._filterQuery = {};
        this._data$ = new BehaviorSubject([]);
        this._imageWidth = null;
        this._imageHeight = null;
        this._config = new GalleryConfig({});
        this._configUpdated$ = new Subject();
        this._destroy$ = new Subject();
        this.dragName += guid();
        this.galleryPreviewService = new FsGalleryPreviewService(_overlay, this._galleryPreviewComponent, _injector, this);
        this.reorderStart$ = this._dragulaService.drag(this.dragName);
        this.reorderEnd$ = this._dragulaService.dragend(this.dragName);
    }
    get data$() {
        return this._data$;
    }
    set data(items) {
        this._data$.next(this.mapData(items));
    }
    get data() {
        return this._data$.getValue();
    }
    get activeFilters$() {
        return this._activeFilters$
            .pipe(debounceTime(200));
    }
    get config() {
        return this._config;
    }
    set config(config) {
        this._config = new GalleryConfig(config);
        this._config.filterInit = this.filterInit.bind(this);
        this._config.filterChange = this.filterChange.bind(this);
        this._initListConfig();
        this._initFilterConfig();
        this._configUpdated$.next();
        if (this._config.persist) {
            this._restorePersistance(this._config.persist);
        }
        if (this._persistanceController.enabled) {
            this._restoreThumbnailScaleParams(this._persistanceController.getDataFromScope('thumbnailScale'));
        }
        this._listenFetch();
        this._listenSizeChange();
        this._listenUpload();
        if (this.config.viewModeGallery) {
            this.loadGallery();
        }
        if (this.config.reorderStart) {
            this._dragulaService.createGroup(this.dragName, {
                moves: (el, source, handle, sibling) => {
                    const group = this._dragulaService.find(this.dragName);
                    const index = Array.from(source.childNodes).indexOf(el);
                    const item = group.drake.models[0][index];
                    return this.config.reorderStart({ item, el, source, handle, sibling });
                }
            });
        }
    }
    get filter() {
        return this._filter;
    }
    setFilter(filter) {
        this._filter = filter;
    }
    setLister(lister) {
        this._lister = lister;
    }
    get imageWidth() {
        return this._imageWidth;
    }
    get imageHeight() {
        return this._imageHeight;
    }
    get fetch$() {
        return this._fetch$.asObservable();
    }
    ngOnDestroy() {
        this._configUpdated$.complete();
        this._destroy$.next();
        this._destroy$.complete();
        this.galleryPreviewService.destroy();
    }
    beforeOpenPreview(item) {
        return this.config.previewBeforeOpen ?
            this.config.previewBeforeOpen(item)
            : of(item);
    }
    closePreview() {
        this.galleryPreviewService.close();
    }
    openPreview(item) {
        if (this.config.previewOpened) {
            this.config.previewOpened(item);
        }
        const galleryPreviewRef = this.galleryPreviewService.open(item);
        galleryPreviewRef
            .onClose
            .pipe(take(1), takeUntil(this._destroy$))
            .subscribe(() => {
            if (this.config.previewClosed) {
                this.config.previewClosed(item);
            }
        });
        return galleryPreviewRef;
    }
    openItem(item) {
        this.navItems.push(item);
        this.loadGallery();
    }
    loadGallery() {
        this._fetch$.next();
    }
    reload() {
        if (this._config.viewModeGallery) {
            this.loadGallery();
        }
        else if (this._config.viewModeList) {
            this._lister.reload();
        }
    }
    mapData(items) {
        return items
            .map((item) => {
            if (this.config.map) {
                item = Object.assign(Object.assign({}, item), this.config.map(item));
            }
            if (!item.mime) {
                item.mime = mime(item.name, item.url, item.extension, item.folder);
            }
            if (!item.mime.color) {
                item.mime.color = mimeColor(item.mime.extension, item.folder);
            }
            item = Object.assign(Object.assign({}, item), { guid: guid(), items: this.mapData(item.items || []) });
            const mimeTypes = {};
            mimeTypes[MimeType.Image] = item.items
                .filter((item) => item.mime.type === MimeType.Image)
                .length;
            mimeTypes[MimeType.Video] = item.items
                .filter((item) => item.mime.type === MimeType.Video)
                .length;
            mimeTypes[MimeType.Audio] = item.items
                .filter((item) => item.mime.type === MimeType.Audio)
                .length;
            mimeTypes[MimeType.Application] = item.items
                .filter((item) => item.mime.type === MimeType.Application)
                .length;
            item.contains = {
                files: Number(Object.values(mimeTypes)
                    .reduce((accum, value) => { return accum + value; }, 0)),
                folders: item.items
                    .filter((item) => item.folder)
                    .length,
                mimeTypes: {},
            };
            return item;
        });
    }
    updateImageDims() {
        this._imageWidth = this.config.thumbnail.width + (this.imageZoom * this.config.thumbnail.width);
        if (this.config.thumbnail.height) {
            this._imageHeight = this.config.thumbnail.height + (this.imageZoom * this.config.thumbnail.height);
        }
        else {
            this._imageHeight = (this._imageWidth * this.config.thumbnail.heightScale);
        }
        this.dimentionsChange$.next();
    }
    updateImageZoom(val) {
        this.imageZoom = val;
        this.imageZoomInteger = round(val, 0);
        this.updateImageDims();
        if (this.config.zoomChanged) {
            this.config.zoomChanged(val);
        }
    }
    filterInit(query) {
        this._filterQuery = query;
        this._activeFilters$.next(Object.keys(query).length);
    }
    filterChange(query) {
        this._filterQuery = query;
        this._activeFilters$.next(Object.keys(query).length);
    }
    setListColumns(columns) {
        this.config.setListColumns(columns);
    }
    getInfoItemName(item) {
        var _a;
        let name = item.name;
        if (((_a = this.config.info) === null || _a === void 0 ? void 0 : _a.name) instanceof Function) {
            name = this.config.info.name(item);
        }
        return name;
    }
    _initFilterConfig() {
        this.filterConfig = {
            items: this.config.filterConfig.items,
            init: this.filterInit.bind(this),
            change: (query) => {
                this.filterChange(query);
                this.reload();
            },
            actions: this.config.filterConfig.actions,
            reload: this.config.reload ? () => {
                this.reload();
            } : null,
        };
        this.config.updateActions$
            .pipe(takeUntil(this._destroy$))
            .subscribe((filterActions) => {
            this.filter.updateActions(filterActions);
        });
    }
    _initListConfig() {
        var _a, _b;
        const rowActions = (((_b = (_a = this.config.info) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.items) || [])
            .filter((item) => item.click);
        let reorder = null;
        if (this.config.reorderEnd) {
            reorder = Object.assign(Object.assign({}, reorder), { done: (rows) => {
                    const rowsData = rows.map((row) => {
                        return row.data;
                    });
                    this.data$.next(rowsData);
                    this.config.reorderEnd(rowsData);
                } });
        }
        if (this.config.reorderStart) {
            reorder = Object.assign(Object.assign({}, reorder), { start: () => {
                    this.config.reorderStart({});
                } });
        }
        this.listConfig = {
            rowActions,
            paging: false,
            selection: this.config.selection,
            emptyState: this.config.emptyState,
            reorder,
            status: false,
            fetch: (query) => {
                query = Object.assign(Object.assign({}, this._filterQuery), query);
                return this.config.fetch(query, null)
                    .pipe(map((items) => {
                    this.data = items;
                    this._updateEmptyState(query, this.data);
                    return {
                        data: this.data,
                        paging: { records: items.length },
                    };
                }));
            }
        };
        if (this.config.noResults !== undefined) {
            this.listConfig.noResults = this.config.noResults;
        }
    }
    _listenFetch() {
        // Should wait until saved filters not loaded
        combineLatest([this.fetch$, this.filtersReady$])
            .pipe(map(() => {
            // const query = {
            //   ...this._filterQuery,
            // };
            return this._filterQuery;
        }), switchMap((query) => {
            if (this._config.fetch) {
                const item = this.navItems[this.navItems.length - 1];
                return this._config.fetch(query, item);
            }
            else {
                return of([]);
            }
        }), map((items) => this.mapData(items)), takeUntil(this._destroy$))
            .subscribe((data) => {
            this._updateEmptyState(this._filterQuery, data);
            this._data$.next(data);
        });
    }
    _listenUpload() {
        this.config.upload$
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            this.reload();
        });
    }
    _listenSizeChange() {
        this._config.thumbnailScale$
            .pipe(takeUntil(this._configUpdated$), takeUntil(this._destroy$))
            .subscribe((size) => {
            if (this._persistanceController.enabled) {
                this._persistanceController.saveDataToScope('thumbnailScale', size);
            }
            switch (size) {
                case ThumbnailScale.Small:
                    {
                        this.config.viewModeGallery
                            ? this.updateImageZoom(-0.1)
                            : this.updateImageZoom(-0.7);
                    }
                    break;
                case ThumbnailScale.Medium:
                    {
                        this.config.viewModeGallery
                            ? this.updateImageZoom(1.3)
                            : this.updateImageZoom(-0.2);
                    }
                    break;
                case ThumbnailScale.Large:
                    {
                        this.config.viewModeGallery
                            ? this.updateImageZoom(3)
                            : this.updateImageZoom(0.3);
                    }
                    break;
                case ThumbnailScale.None:
                    {
                        this.config.viewModeGallery
                            ? this.updateImageZoom(0)
                            : this.updateImageZoom(0);
                    }
                    break;
            }
        });
    }
    _restorePersistance(persistConfig) {
        const namespace = getNormalizedPath(this._location);
        this._persistanceController.setConfig(persistConfig, namespace);
    }
    _restoreThumbnailScaleParams(value) {
        if (value) {
            this._config.setThumbnailScale(value);
        }
    }
    _updateEmptyState(filterQuery, items) {
        var _a, _b;
        if (((_a = this.config.emptyState) === null || _a === void 0 ? void 0 : _a.validate) && this.emptyStateTemplate) {
            this.emptyStateEnabled = (_b = this.config.emptyState) === null || _b === void 0 ? void 0 : _b.validate(filterQuery, items);
        }
    }
}
FsGalleryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryService, deps: [{ token: GalleryPreviewComponentInjector }, { token: i1$3.Overlay }, { token: i0.Injector }, { token: i2.Location }, { token: i3.DragulaService }, { token: PersistanceController }], target: i0.ɵɵFactoryTarget.Injectable });
FsGalleryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [GalleryPreviewComponentInjector]
                }] }, { type: i1$3.Overlay }, { type: i0.Injector }, { type: i2.Location }, { type: i3.DragulaService }, { type: PersistanceController }]; } });

class FsGalleryPreviewDetailsComponent {
}
FsGalleryPreviewDetailsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewDetailsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsGalleryPreviewDetailsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryPreviewDetailsComponent, selector: "fs-gallery-preview-details", inputs: { item: "item", galleryService: "galleryService", image: "image" }, ngImport: i0, template: "<div class=\"container\">\n  <div class=\"header\">\n    <div mat-dialog-title>Details</div>\n  </div>\n  <div class=\"content\">\n    <ng-container *ngIf=\"galleryService.previewDetails; else template\">\n      <ng-template [ngTemplateOutlet]=\"galleryService.previewDetails.templateRef\"\n        [ngTemplateOutletContext]=\"{ item: item, template: template }\">\n      </ng-template>\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #template>\n  <fs-label-field>\n    <fs-label>File</fs-label>\n    {{item.name}}\n    <div \n        class=\"small\"\n        *ngIf=\"image\">\n      {{image.width}} x {{image.height}}\n    </div>\n  </fs-label-field>\n</ng-template>", styles: [".container{width:300px;padding:10px 18px;box-sizing:border-box}.container .header{display:flex;align-items:center;margin-bottom:15px}.container .header .mat-dialog-title{flex-grow:1;margin:0}\n"], components: [{ type: i1$4.FsLabelFieldComponent, selector: "fs-label-field", inputs: ["bottomMargin", "topMargin", "labelMargin"] }, { type: i1$4.FsLabelComponent, selector: "fs-label" }], directives: [{ type: i2$2.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewDetailsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-preview-details',
                    templateUrl: './gallery-preview-details.component.html',
                    styleUrls: ['./gallery-preview-details.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { item: [{
                type: Input
            }], galleryService: [{
                type: Input
            }], image: [{
                type: Input
            }] } });

class FsGalleryMenuComponent {
    constructor() {
        this.visibleMenuItems = [];
    }
    ngOnChanges(changes) {
        if (changes.menuItems) {
            this.visibleMenuItems = processMenuItems(this.menuItems, this.item);
        }
    }
    menuItemClick(menuItem) {
        if (menuItem.click) {
            menuItem.click(this.item);
        }
    }
}
FsGalleryMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsGalleryMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryMenuComponent, selector: "fs-gallery-menu", inputs: { item: "item", menuItems: "menuItems" }, usesOnChanges: true, ngImport: i0, template: "\n<ng-container *ngIf=\"visibleMenuItems.length\">\n  <fs-menu>\n    <ng-container *ngFor=\"let menuItem of visibleMenuItems\">\n      <ng-template \n          *ngIf=\"!menuItem.select\"\n          fs-menu-item             \n          (click)=\"menuItemClick(menuItem)\">\n        {{menuItem.label}}\n      </ng-template>\n      <ng-template \n          *ngIf=\"menuItem.select\"\n          fs-menu-file-item \n          [multiple]=\"menuItem.multiple\"\n          (select)=\"menuItem.select(item, $event)\">\n        {{menuItem.label}}\n      </ng-template>\n    </ng-container>\n  </fs-menu>\n", styles: [""], components: [{ type: i1$5.FsMenuComponent, selector: "fs-menu", inputs: ["class", "buttonClass", "buttonType", "buttonColor"], outputs: ["opened", "closed"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$5.FsMenuItemDirective, selector: "fs-menu-group,[fs-menu-item]" }, { type: i1$5.FsMenuFileItemDirective, selector: "[fs-menu-file-item]", inputs: ["multiple", "accept", "minWidth", "minHeight", "imageWidth", "imageHeight"], outputs: ["select", "error"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryMenuComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-menu',
                    templateUrl: './gallery-menu.component.html',
                    styleUrls: ['./gallery-menu.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { item: [{
                type: Input
            }], menuItems: [{
                type: Input
            }] } });

class FsGalleryPreviewHeaderComponent {
    constructor() {
        this.previewClosed = new EventEmitter();
        this.detailsToggled = new EventEmitter();
        this.previewMenuItems = [];
        this.previewActions = [];
    }
    ngOnChanges(changes) {
        var _a;
        if (changes.item) {
            this.previewMenuItems = ((_a = this.galleryService.config.previewMenu) === null || _a === void 0 ? void 0 : _a.items) || [];
            this.previewActions = this._processGalleryItemAction(this.galleryService.config.previewActions);
        }
    }
    previewActionClick(action) {
        if (action.click) {
            action.click(this.item);
        }
        if (action.download) {
            if (this.item.url instanceof FsApiFile) {
                this.item.url.download();
            }
            else if (this.item.url instanceof File) {
                (new FsFile(this.item.url))
                    .download();
            }
            else if (this.item.url instanceof FsFile) {
                this.item.url.download();
            }
            else {
                const url = new URL(this.item.url);
                const link = document.createElement('a');
                link.href = this.item.url;
                link.download = url.pathname.split('/').pop();
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    _processGalleryItemAction(actions) {
        return actions
            .filter((item) => {
            return !item.show || item.show(this.item);
        });
    }
}
FsGalleryPreviewHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsGalleryPreviewHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryPreviewHeaderComponent, selector: "fs-gallery-preview-header", inputs: { item: "item", galleryService: "galleryService" }, outputs: { previewClosed: "previewClosed", detailsToggled: "detailsToggled" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"header\">\n  <div class=\"actions left\">\n    <button \n        mat-icon-button \n        type=\"button\" \n        class=\"action\" \n        (click)=\"previewClosed.emit()\">\n      <mat-icon>close</mat-icon>\n    </button>\n  </div>\n  <div class=\"actions right\">  \n    <ng-container *ngFor=\"let previewAction of previewActions\">\n      <ng-container *ngIf=\"previewAction.select\">\n        <fs-file class=\"action\" (select)=\"previewAction.select(item, $event)\">\n          <ng-container \n            [ngTemplateOutlet]=\"previewActionButton\"\n            [ngTemplateOutletContext]=\"{ previewAction: previewAction }\">\n          </ng-container>\n        </fs-file>\n      </ng-container>\n      <ng-container *ngIf=\"!previewAction.select\">\n        <span class=\"action\">\n          <ng-container \n            [ngTemplateOutlet]=\"previewActionButton\"\n            [ngTemplateOutletContext]=\"{ previewAction: previewAction }\">\n          </ng-container>\n        </span>\n      </ng-container>      \n    </ng-container>\n    <button \n        *ngIf=\"galleryService.config.details\"\n        mat-icon-button \n        type=\"button\" \n        class=\"action\" \n        (click)=\"detailsToggled.emit()\"\n        [matTooltip]=\"'Details'\">\n      <mat-icon>info_outline</mat-icon>\n    </button>\n    <fs-gallery-menu\n      [item]=\"item\"\n      [menuItems]=\"previewMenuItems\">\n    </fs-gallery-menu>\n  </div>\n</div>\n\n<ng-template #previewActionButton let-previewAction=\"previewAction\">\n  <button \n      mat-icon-button \n      type=\"button\" \n      (click)=\"previewActionClick(previewAction)\"\n      [matTooltip]=\"previewAction.tooltip\">\n    <mat-icon>{{previewAction.icon}}</mat-icon>\n  </button>\n</ng-template>", styles: [".header{padding:10px;box-sizing:border-box;display:flex}.header .actions{z-index:1;position:relative;display:flex;flex-direction:row;align-items:center}.header .actions .action+.action,.header .actions fs-menu{margin-left:8px}.header .actions.left{justify-content:flex-start;flex-grow:1}.header .actions.right{justify-content:flex-end;flex-grow:inherit}.header .actions mat-icon,.header .actions ::ng-deep fs-menu mat-icon{color:#fff}\n"], components: [{ type: i1$6.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i2$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i3$1.FsFileComponent, selector: "fs-file", inputs: ["minHeight", "minWidth", "orientate", "multiple", "capture", "allowClick", "allowDrop", "accept", "disabled", "imageWidth", "imageHeight", "imageQuality"], outputs: ["select", "error", "beforeProcessing", "clicked", "declined"] }, { type: FsGalleryMenuComponent, selector: "fs-gallery-menu", inputs: ["item", "menuItems"] }], directives: [{ type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-preview-header',
                    templateUrl: './gallery-preview-header.component.html',
                    styleUrls: ['./gallery-preview-header.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { item: [{
                type: Input
            }], galleryService: [{
                type: Input
            }], previewClosed: [{
                type: Output
            }], detailsToggled: [{
                type: Output
            }] } });

class FsGalleryPreviewComponent {
    constructor(_item, galleryService, renderer, _router, _previewRef, _el) {
        this._item = _item;
        this.galleryService = galleryService;
        this.renderer = renderer;
        this._router = _router;
        this._previewRef = _previewRef;
        this._el = _el;
        this.classCarousel = false;
        this.imageHover = false;
        this.MimeType = MimeType;
        this.hasMultipleItems = false;
        this.drawerShow = true;
        this.drawerMode = 'side';
        this.activeImageIndex = 0;
        this._destroy$ = new Subject();
    }
    onKeydownHandler(event) {
        switch (event.keyCode) {
            case 27:
                this._previewRef.close();
                break;
            case 37:
                this.prevItem();
                break;
            case 39:
                this.nextItem();
                break;
        }
    }
    ngOnInit() {
        this._initAvailableImages();
        this.setActiveItem(this._item);
        this.classCarousel = this.galleryConfig.showCarousel;
        this.drawer.opened = window.innerWidth > 600 && this.galleryConfig.details.autoOpen;
        this._router.events
            .pipe(takeUntil(this._destroy$), filter(event => event instanceof NavigationStart))
            .subscribe((event) => {
            this._previewRef.close();
        });
    }
    get galleryConfig() {
        return this.galleryService.config;
    }
    get hasPrevItem() {
        return this.activeImageIndex > 0;
    }
    get hasNextItem() {
        return this.activeImageIndex < (this.availableImages.length - 1);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
        this.renderer.removeClass(document.body, 'fs-gallery-preview-open');
    }
    close() {
        this._previewRef.close();
    }
    detailsToggled() {
        this.drawer.opened = !this.drawer.opened;
    }
    imageLoad(event) {
        this.activeImage = {
            height: event.target.naturalHeight,
            width: event.target.naturalWidth,
        };
    }
    prevItem() {
        const item = this.availableImages[this.activeImageIndex - 1];
        if (item) {
            this.setActiveItem(item);
        }
        else {
            this.setActiveItem(this.availableImages[this.availableImages.length - 1]);
        }
    }
    nextItem() {
        const item = this.availableImages[this.activeImageIndex + 1];
        if (item) {
            this.setActiveItem(item);
        }
        else {
            this.setActiveItem(this.availableImages[0]);
        }
    }
    setActiveItem(item) {
        this.activeItem = item;
        this.activeImageIndex = this.availableImages
            .findIndex((item) => { var _a; return ((_a = this.activeItem) === null || _a === void 0 ? void 0 : _a.guid) === item.guid; });
        setTimeout(() => {
            const el = this._el.nativeElement.querySelector(`fs-gallery-preview-carousel [data-index='${this.activeImageIndex}']`);
            el === null || el === void 0 ? void 0 : el.scrollIntoView({ block: 'center', inline: 'center' });
        });
    }
    _initAvailableImages() {
        this.availableImages = this.galleryService.data$.getValue()
            .filter((item) => {
            return !item.folder;
        });
        this.hasMultipleItems = this.availableImages.length > 1;
    }
}
FsGalleryPreviewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewComponent, deps: [{ token: PREVIEW_DATA }, { token: FsGalleryService }, { token: i0.Renderer2 }, { token: i2$1.Router }, { token: FsGalleryPreviewRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FsGalleryPreviewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryPreviewComponent, selector: "ng-component", host: { listeners: { "document:keydown": "onKeydownHandler($event)" }, properties: { "class.carousel": "this.classCarousel" } }, viewQueries: [{ propertyName: "drawer", first: true, predicate: MatDrawer, descendants: true, static: true }], ngImport: i0, template: "<div class=\"fs-gallery-preview\" [ngClass]=\"{ 'multiple': hasMultipleItems }\">\n  <mat-drawer-container   \n      class=\"example-container\">\n    <mat-drawer \n        (openedStart)=\"drawerShow = true\"\n        (closedStart)=\"drawerShow = false\"\n        [mode]=\"drawerMode\" \n        [ngClass]=\"{ show: drawerShow }\"\n        [opened]=\"drawer.opened && !!galleryConfig.details\" \n        [position]=\"'end'\">\n      <fs-gallery-preview-details  \n        [item]=\"activeItem\"    \n        [galleryService]=\"galleryService\"  \n        [image]=\"activeImage\"\n        (detailsToggled)=\"detailsToggled()\">\n      </fs-gallery-preview-details>\n    </mat-drawer>\n    <mat-drawer-content>   \n      <fs-gallery-preview-header\n        [galleryService]=\"galleryService\"\n        [item]=\"activeItem\"\n        (previewClosed)=\"close()\"\n        (detailsToggled)=\"detailsToggled()\">\n      </fs-gallery-preview-header>\n\n      <div class=\"preview\" [class]=\"'file file-' + activeItem.mime.type + ' extension-' + activeItem.mime.extension\">        \n        <a class=\"prev-overlay\" *ngIf=\"hasPrevItem\" (click)=\"prevItem()\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z\"/></svg>\n        </a>\n        <a class=\"next-overlay\" *ngIf=\"hasNextItem\" (click)=\"nextItem()\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z\"/></svg>\n        </a>\n        <ng-container [ngSwitch]=\"activeItem.mime.type\">\n          <ng-template [ngSwitchCase]=\"MimeType.Application\">\n            <ng-container *ngIf=\"activeItem.mime.extension === 'pdf'; else fileIcon\">\n              <fs-pdf-viewer \n                [backgroundColor]=\"'transparent'\"\n                [pdf]=\"activeItem.url\">\n              </fs-pdf-viewer>\n            </ng-container>            \n          </ng-template>\n          <ng-template [ngSwitchCase]=\"MimeType.Image\">\n            <ng-container *ngIf=\"(activeItem.url | imageSrc | async) as image\">\n              <img class=\"image\" \n                (load)=\"imageLoad($event)\"\n                [src]=\"image\" \n                (swipeleft)=\"nextItem()\"\n                (swiperight)=\"prevItem()\">\n            </ng-container>\n          </ng-template>\n          <ng-template ngSwitchDefault>\n            <ng-container [ngTemplateOutlet]=\"fileIcon\"></ng-container>\n          </ng-template>\n        </ng-container>\n\n        <ng-template #fileIcon>\n          <fs-gallery-file-icon \n            [width]=\"150\"\n            [item]=\"activeItem\">\n          </fs-gallery-file-icon>\n        </ng-template>\n      </div>\n      \n      <fs-gallery-preview-carousel \n        *ngIf=\"hasMultipleItems\" \n        [items]=\"availableImages\" \n        [activeItem]=\"activeItem\"\n        (activeItemChanged)=\"setActiveItem($event)\">\n      </fs-gallery-preview-carousel>\n\n    </mat-drawer-content>\n  </mat-drawer-container>\n</div>\n<div class=\"fs-gallery-preview-backdrop\"></div>", styles: [".fs-gallery-preview-open{overflow:hidden}.fs-gallery-no-results{text-align:center;color:#999;padding:10px 0}.fs-gallery-preview-backdrop{position:absolute;top:0;bottom:0;left:0;right:0;z-index:2000;outline:none;overflow:visible;background:radial-gradient(circle at 91.25% 19.54%,#a78ba2,transparent 36%),radial-gradient(circle at 50.63% 43.17%,#57757c,transparent 61%),radial-gradient(circle at 13.06% 16.67%,#405459,transparent 70%),radial-gradient(circle at 12.99% 74.73%,#191723,transparent 100%),radial-gradient(circle at 88.33% 83.33%,#222537,transparent 100%),radial-gradient(circle at 50% 50%,#ffffff,#ffffff 100%)}.fs-gallery-preview-backdrop[hidden]{display:none!important}.fs-gallery-preview{z-index:3000;display:flex;position:absolute;width:100%;bottom:0;top:0;left:0}.fs-gallery-preview .preview{height:100%;width:100%;position:relative;min-height:0;-webkit-user-select:none;user-select:none}.fs-gallery-preview .preview:not(.extension-pdf){display:flex;justify-content:center;align-items:center}.fs-gallery-preview .preview.extension-pdf{overflow:auto}.fs-gallery-preview .preview .image{display:flex;vertical-align:middle;max-width:100%;max-height:100%;object-fit:contain;width:auto!important;height:auto!important}.fs-gallery-preview .preview.extension-pdf .prev-overlay,.fs-gallery-preview .preview.extension-pdf .next-overlay{position:sticky}.fs-gallery-preview .prev-overlay,.fs-gallery-preview .next-overlay{position:absolute;top:0;width:50%;-webkit-user-select:none;user-select:none;z-index:999;display:block;float:left;height:100%}.fs-gallery-preview .prev-overlay svg,.fs-gallery-preview .next-overlay svg{position:absolute;top:50%}.fs-gallery-preview .prev-overlay.prev-overlay,.fs-gallery-preview .next-overlay.prev-overlay{left:0}.fs-gallery-preview .prev-overlay.prev-overlay svg,.fs-gallery-preview .next-overlay.prev-overlay svg{left:50px}.fs-gallery-preview .prev-overlay.next-overlay,.fs-gallery-preview .next-overlay.next-overlay{right:0}.fs-gallery-preview .prev-overlay.next-overlay svg,.fs-gallery-preview .next-overlay.next-overlay svg{right:50px}.fs-gallery-preview .prev-overlay:hover svg,.fs-gallery-preview .next-overlay:hover svg{visibility:visible}.fs-gallery-preview .prev-overlay svg,.fs-gallery-preview .next-overlay svg{width:40px;fill:#f5f5f5;text-shadow:beige;filter:drop-shadow(3px 5px 2px rgba(0,0,0,.3));visibility:hidden}:host.carousel .fs-gallery-preview.multiple .image-wrap{cursor:pointer}:host ::ng-deep .mat-drawer:not(.mat-drawer-opened,.ng-animating){right:unset;left:0}:host ::ng-deep .mat-drawer-container{background-color:transparent;width:100%}:host ::ng-deep .mat-drawer-container .mat-drawer-backdrop{background-color:transparent}:host ::ng-deep .mat-drawer-container .mat-drawer-content{display:flex;flex-direction:column;padding-bottom:10px;box-sizing:border-box}\n"], components: [{ type: i4.MatDrawerContainer, selector: "mat-drawer-container", inputs: ["autosize", "hasBackdrop"], outputs: ["backdropClick"], exportAs: ["matDrawerContainer"] }, { type: i4.MatDrawer, selector: "mat-drawer", inputs: ["position", "mode", "disableClose", "autoFocus", "opened"], outputs: ["openedChange", "opened", "openedStart", "closed", "closedStart", "positionChanged"], exportAs: ["matDrawer"] }, { type: FsGalleryPreviewDetailsComponent, selector: "fs-gallery-preview-details", inputs: ["item", "galleryService", "image"] }, { type: i4.MatDrawerContent, selector: "mat-drawer-content" }, { type: FsGalleryPreviewHeaderComponent, selector: "fs-gallery-preview-header", inputs: ["item", "galleryService"], outputs: ["previewClosed", "detailsToggled"] }, { type: i7.FsPdfViewerComponent, selector: "fs-pdf-viewer", inputs: ["pdf", "height", "backgroundColor", "pageViewMode", "zoom"], outputs: ["init", "pageRendered"] }, { type: FsGalleryFileIconComponent, selector: "fs-gallery-file-icon", inputs: ["item", "width", "height"] }, { type: FsGalleryPreviewCarouselComponent, selector: "fs-gallery-preview-carousel", inputs: ["items", "activeItem"], outputs: ["activeItemChanged"] }], directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i2.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "async": i2.AsyncPipe, "imageSrc": ImageSrcPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewComponent, decorators: [{
            type: Component,
            args: [{
                    templateUrl: './gallery-preview.component.html',
                    styleUrls: ['./gallery-preview.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PREVIEW_DATA]
                }] }, { type: FsGalleryService }, { type: i0.Renderer2 }, { type: i2$1.Router }, { type: FsGalleryPreviewRef }, { type: i0.ElementRef }]; }, propDecorators: { drawer: [{
                type: ViewChild,
                args: [MatDrawer, { static: true }]
            }], classCarousel: [{
                type: HostBinding,
                args: ['class.carousel']
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class FsGalleryThumbnailPreviewComponent {
    constructor(galleryService) {
        this.galleryService = galleryService;
        this.MimeType = MimeType;
        this.GalleryThumbnailSize = GalleryThumbnailSize;
        this.styles = {
            width: null,
            height: null,
        };
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        this.preview = this.item.preview;
    }
    ngOnChanges(changes) {
        if (changes.imageWidth || changes.imageHeight) {
            if (this.imageHeight > this.imageWidth) {
                this.iconHeight = this.imageHeight * .7;
                this.iconHeight = this.iconHeight > 90 ? 90 : this.iconHeight;
                this.iconWidth = null;
            }
            else {
                this.iconWidth = this.imageWidth * .5;
                this.iconWidth = this.iconWidth > 70 ? 70 : this.iconWidth;
                this.iconHeight = null;
            }
        }
    }
    click(item) {
        if (item.folder) {
            this.galleryService.openItem(item);
        }
        else {
            if (this.galleryService.config.preview) {
                this.galleryService.beforeOpenPreview(item)
                    .pipe(filter((item) => !!item), takeUntil(this._destroy$))
                    .subscribe((item) => {
                    this.galleryService.openPreview(item);
                });
                if (this.galleryService.config.previewClick) {
                    this.galleryService.config.previewClick(item);
                }
            }
        }
    }
    get config() {
        return this.galleryService.config;
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
FsGalleryThumbnailPreviewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailPreviewComponent, deps: [{ token: FsGalleryService }], target: i0.ɵɵFactoryTarget.Component });
FsGalleryThumbnailPreviewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryThumbnailPreviewComponent, selector: "fs-gallery-thumbnail-preview", inputs: { item: "item", imageHeight: "imageHeight", imageWidth: "imageWidth" }, usesOnChanges: true, ngImport: i0, template: "<div  \n    (click)=\"click(item)\"\n    class=\"file\"\n    [style.height]=\"(imageHeight ? imageHeight + 'px' :null)\"\n    [style.width]=\"(imageWidth ? imageWidth + 'px' :null)\"\n    [ngClass]=\"{\n      'previewable': config.preview && !!preview  ,\n      'file-folder': item.folder,\n      'file-image': item.mime.type === MimeType.Image,\n      'file-video': item.mime.type === MimeType.Video,\n      'file-audio': item.mime.type === MimeType.Audio,\n      'file-application': item.mime.type === MimeType.Application\n    }\">\n  <ng-container *ngIf=\"galleryService.thumbnailPreviewTemplate; else template\">\n    <ng-template\n      [ngTemplateOutlet]=\"galleryService.thumbnailPreviewTemplate\"\n      [ngTemplateOutletContext]=\"{ item: item, template: template }\">\n    </ng-template>\n  </ng-container>\n</div>\n\n<ng-template #template>\n  <ng-container *ngIf=\"(preview | imageSrc:config.thumbnail.size === GalleryThumbnailSize.Cover | async) as preview; else fileIcon\">      \n    <ng-container [ngSwitch]=\"item.mime.type\">\n      <ng-template [ngSwitchCase]=\"MimeType.Image\">\n        <ng-container *ngIf=\"config.thumbnail.size === GalleryThumbnailSize.Cover\">\n          <div class=\"image-cover\"        \n            [style.backgroundSize]=\"config.thumbnail.size\"\n            [style.backgroundPosition]=\"config.thumbnail.position\"\n            [style.backgroundImage]=\"preview\">\n          </div> \n        </ng-container>\n        <ng-container *ngIf=\"config.thumbnail.size === GalleryThumbnailSize.Contain\">\n          <img class=\"image-contain\" [src]=\"preview\">\n        </ng-container>\n      </ng-template>\n    \n      <ng-template ngSwitchDefault>\n        <ng-container [ngTemplateOutlet]=\"fileIcon\"></ng-container>\n      </ng-template>\n    </ng-container>\n  </ng-container>\n</ng-template>\n\n<ng-template #fileIcon>\n  <fs-gallery-file-icon \n    [width]=\"iconWidth\"\n    [height]=\"iconHeight\"\n    [item]=\"item\">\n  </fs-gallery-file-icon>\n</ng-template>", styles: [".file{display:flex;align-items:center;justify-content:center;height:100%}.file .file-name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 5px;font-size:12px;text-align:center;width:100%}.file.previewable{cursor:pointer}.file:not(.previewable){min-width:150px;min-height:100px}.file.file-image{display:block}.file.file-image .image-cover,.file.file-image .image-contain{border-radius:4px}.file.file-image .image-cover{width:100%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:top center}.file.file-image .image-cover.portrait{background-size:auto 100%}.file.file-image .image-contain{height:100%;width:100%;min-width:50px}\n"], components: [{ type: FsGalleryFileIconComponent, selector: "fs-gallery-file-icon", inputs: ["item", "width", "height"] }], directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i2.NgSwitchDefault, selector: "[ngSwitchDefault]" }], pipes: { "async": i2.AsyncPipe, "imageSrc": ImageSrcPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailPreviewComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-thumbnail-preview',
                    templateUrl: './gallery-thumbnail-preview.component.html',
                    styleUrls: ['./gallery-thumbnail-preview.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: FsGalleryService }]; }, propDecorators: { item: [{
                type: Input
            }], imageHeight: [{
                type: Input
            }], imageWidth: [{
                type: Input
            }] } });

class FsGalleryIconComponent {
    constructor() {
        this.item = null;
        this.MimeType = MimeType;
    }
}
FsGalleryIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsGalleryIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryIconComponent, selector: "fs-gallery-icon", inputs: { item: "item" }, ngImport: i0, template: "<mat-icon [style.color]=\"item.mime.color\">\n  <ng-container [ngSwitch]=\"item.mime.type\">\n    <ng-container *ngSwitchCase=\"MimeType.Image\">image</ng-container>\n    <ng-container *ngSwitchCase=\"MimeType.Application\">insert_drive_file</ng-container>\n    <ng-container *ngSwitchCase=\"MimeType.Video\">videocam</ng-container>\n    <ng-container *ngSwitchDefault>\n      <ng-container *ngIf=\"item.folder\">folder</ng-container>\n    </ng-container>\n  </ng-container>\n</mat-icon>", styles: ["mat-icon{display:flex}\n"], components: [{ type: i2$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i2.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-icon',
                    templateUrl: './gallery-icon.component.html',
                    styleUrls: ['./gallery-icon.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { item: [{
                type: Input
            }] } });

class FsGalleryThumbnailInfoComponent {
    constructor(galleryService) {
        this.galleryService = galleryService;
        this.hasInfo = false;
        this.hasInfoChange = new EventEmitter();
        this.MimeType = MimeType;
    }
    ngOnInit() {
        var _a, _b;
        if (this.showIcon === undefined) {
            this.showIcon = this.galleryService.config.info.icon !== false;
        }
        if (this.menuItems === undefined) {
            this.menuItems = ((_b = (_a = this.galleryService.config.info) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.items) || [];
        }
        if (this.name === undefined) {
            this.name = this.galleryService.getInfoItemName(this.item);
        }
    }
    select(action, file) {
        action.select(this.item, file);
    }
    menuClick(event, action, data) {
        if (action.click) {
            action.click(data);
        }
    }
}
FsGalleryThumbnailInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailInfoComponent, deps: [{ token: FsGalleryService }], target: i0.ɵɵFactoryTarget.Component });
FsGalleryThumbnailInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryThumbnailInfoComponent, selector: "fs-gallery-thumbnail-info", inputs: { item: "item", hasInfo: "hasInfo", showIcon: "showIcon", menuItems: "menuItems", name: "name" }, outputs: { hasInfoChange: "hasInfoChange" }, ngImport: i0, template: "<ng-container *ngIf=\"showIcon || name || !!menuItems.length\">\n  <div class=\"info\">\n    <div\n        *ngIf=\"item.mime.type && showIcon\"\n        class=\"icon\">\n      <fs-gallery-icon [item]=\"item\"></fs-gallery-icon>\n    </div>\n    <div class=\"name\" \n        *ngIf=\"name\"\n        [matTooltip]=\"item.name\" \n        [matTooltipClass]=\"'gallery-thumbnail-tooltip'\">\n      <div>{{ name }}</div>\n    </div>\n    <fs-gallery-menu\n      [item]=\"item\"\n      [menuItems]=\"menuItems\">\n    </fs-gallery-menu>\n  </div>\n</ng-container>", styles: [":host{overflow:hidden}::ng-deep .gallery-thumbnail-tooltip{margin-top:-4px!important}.info{display:flex;flex-direction:row;align-items:stretch;font-size:90%;box-sizing:border-box;padding:0 7px;height:40px;justify-content:flex-end}.info .tags{display:flex;position:relative;flex-wrap:wrap;padding:2px 4px}.info .tags ::ng-deep .pill{margin-right:4px}.info .icon{margin-right:5px;align-items:center;display:flex}.info .name{display:flex;position:relative;min-width:0;color:#000;box-sizing:border-box;flex:1;align-items:center}.info .name div{position:absolute;width:100%;align-items:center;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.info .name .description{font-size:80%}.info fs-gallery-menu{align-items:center;display:flex}::ng-deep fs-gallery-thumbnail.gu-mirror .info{display:none}\n"], components: [{ type: FsGalleryIconComponent, selector: "fs-gallery-icon", inputs: ["item"] }, { type: FsGalleryMenuComponent, selector: "fs-gallery-menu", inputs: ["item", "menuItems"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailInfoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-thumbnail-info',
                    templateUrl: './gallery-thumbnail-info.component.html',
                    styleUrls: ['./gallery-thumbnail-info.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: FsGalleryService }]; }, propDecorators: { item: [{
                type: Input
            }], hasInfo: [{
                type: Input
            }], showIcon: [{
                type: Input
            }], menuItems: [{
                type: Input
            }], name: [{
                type: Input
            }], hasInfoChange: [{
                type: Output
            }] } });

class FsGalleryThumbnailComponent {
    constructor(galleryService, _cdRef) {
        this.galleryService = galleryService;
        this._cdRef = _cdRef;
        this.item = null;
        this.galleryLayout = GalleryLayout;
        this.hasInfo = false;
        this.infoMenuItems = [];
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        var _a, _b;
        this.galleryService.config.thumbnailScale$
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            this._cdRef.markForCheck();
        });
        this.infoMenuItems = processMenuItems(((_b = (_a = this.galleryService.config.info) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.items) || [], this.item);
        this.hasInfo = (!!this.galleryService.config.info.icon ||
            !!this.galleryService.config.info.name ||
            !!this.infoMenuItems.length ||
            !!this.galleryService.getInfoItemName(this.item));
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
FsGalleryThumbnailComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailComponent, deps: [{ token: FsGalleryService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsGalleryThumbnailComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryThumbnailComponent, selector: "fs-gallery-thumbnail", inputs: { item: "item", index: "index", first: "first", last: "last" }, ngImport: i0, template: "<div\n    class=\"fs-gallery-thumbnail\"\n    [ngClass]=\"{ \n      'layout-grid': galleryService.config.layout === galleryLayout.Grid,\n      'layout-flow': galleryService.config.layout === galleryLayout.Flow,\n      'has-info': hasInfo\n    }\"\n    id=\"fs-gallery-thumbnail-{{ item.index }}\"\n    [style.width]=\"galleryService.config.layout===galleryLayout.Grid ? '' : (galleryService.imageWidth ? galleryService.imageWidth + 'px' : null)\">\n  <ng-container\n    *ngIf=\"galleryService.thumbnailTemplate; else template\">\n      <ng-template\n        [ngTemplateOutlet]=\"galleryService.thumbnailTemplate\"\n        [ngTemplateOutletContext]=\"{ \n          item: item, \n          template: template, \n          previewTemplate: previewTemplate,\n          infoTemplate: infoTemplate,\n          first: first,\n          last: last,\n          index: index\n        }\">\n      </ng-template>\n  </ng-container>\n</div>\n\n<ng-template #template>\n  <fs-gallery-thumbnail-preview  \n    [imageHeight]=\"galleryService.imageHeight\" \n    [imageWidth]=\"galleryService.config.layout===galleryLayout.Grid ? null : (galleryService.imageWidth ? galleryService.imageWidth : null)\"\n    [item]=\"item\">\n  </fs-gallery-thumbnail-preview>\n\n  <fs-gallery-thumbnail-info \n    [item]=\"item\"\n    [menuItems]=\"infoMenuItems\">\n  </fs-gallery-thumbnail-info>\n</ng-template>\n\n<ng-template #previewTemplate>\n  <fs-gallery-thumbnail-preview  \n    [imageHeight]=\"galleryService.imageHeight\" \n    [imageWidth]=\"galleryService.config.layout===galleryLayout.Grid ? null : (galleryService.imageWidth ? galleryService.imageWidth : null)\"\n    [item]=\"item\">\n  </fs-gallery-thumbnail-preview>\n</ng-template>\n\n<ng-template #infoTemplate>\n  <fs-gallery-thumbnail-info \n    *ngIf=\"hasInfo\"\n    [item]=\"item\">\n  </fs-gallery-thumbnail-info>\n</ng-template>\n\n", styles: [".fs-gallery-thumbnail{display:block;position:relative;border-radius:4px;border:1px solid #f0f0f0;box-sizing:border-box;background-color:#fff}.fs-gallery-thumbnail.layout-grid{height:100%}.fs-gallery-thumbnail.layout-flow{flex-direction:column}.fs-gallery-thumbnail.has-info ::ng-deep .image-cover,.fs-gallery-thumbnail.has-info ::ng-deep .image-contain{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}\n"], components: [{ type: FsGalleryThumbnailPreviewComponent, selector: "fs-gallery-thumbnail-preview", inputs: ["item", "imageHeight", "imageWidth"] }, { type: FsGalleryThumbnailInfoComponent, selector: "fs-gallery-thumbnail-info", inputs: ["item", "hasInfo", "showIcon", "menuItems", "name"], outputs: ["hasInfoChange"] }], directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-thumbnail',
                    templateUrl: './gallery-thumbnail.component.html',
                    styleUrls: ['./gallery-thumbnail.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: FsGalleryService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { item: [{
                type: Input
            }], index: [{
                type: Input
            }], first: [{
                type: Input
            }], last: [{
                type: Input
            }] } });

class FsGalleryPreviewDetailsDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
FsGalleryPreviewDetailsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewDetailsDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
FsGalleryPreviewDetailsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryPreviewDetailsDirective, selector: "[fsGalleryPreviewDetails]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewDetailsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsGalleryPreviewDetails]'
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FsGalleryNavDirective {
}
FsGalleryNavDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryNavDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsGalleryNavDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryNavDirective, selector: "[fsGalleryNav]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryNavDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsGalleryNav]'
                }]
        }] });

class FsGalleryPreviewDirective {
}
FsGalleryPreviewDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsGalleryPreviewDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryPreviewDirective, selector: "[fsGalleryPreview]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryPreviewDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsGalleryPreview]'
                }]
        }] });

class FsGalleryThumbnailPreviewDirective {
}
FsGalleryThumbnailPreviewDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailPreviewDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsGalleryThumbnailPreviewDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryThumbnailPreviewDirective, selector: "[fsGalleryThumbnailPreview]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailPreviewDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsGalleryThumbnailPreview]'
                }]
        }] });

class FsGalleryThumbnailDirective {
}
FsGalleryThumbnailDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsGalleryThumbnailDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryThumbnailDirective, selector: "[fsGalleryThumbnail]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryThumbnailDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsGalleryThumbnail]'
                }]
        }] });

class FsGalleryListCellDirective {
}
FsGalleryListCellDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryListCellDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsGalleryListCellDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryListCellDirective, selector: "[fs-gallery-list-cell],[fsGalleryListCell]", inputs: { colspan: "colspan", align: "align", className: ["class", "className"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryListCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fs-gallery-list-cell],[fsGalleryListCell]'
                }]
        }], propDecorators: { colspan: [{
                type: Input
            }], align: [{
                type: Input
            }], className: [{
                type: Input,
                args: ['class']
            }] } });

class FsGalleryListHeaderDirective {
}
FsGalleryListHeaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryListHeaderDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsGalleryListHeaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryListHeaderDirective, selector: "[fs-gallery-list-header]", inputs: { colspan: "colspan", align: "align", className: ["class", "className"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryListHeaderDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[fs-gallery-list-header]' }]
        }], propDecorators: { colspan: [{
                type: Input
            }], align: [{
                type: Input
            }], className: [{
                type: Input,
                args: ['class']
            }] } });

class FsGalleryListColumnDirective {
    constructor() {
        this.show = true;
        this.customize = true;
    }
}
FsGalleryListColumnDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryListColumnDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsGalleryListColumnDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryListColumnDirective, selector: "fs-gallery-list-column", inputs: { title: "title", name: "name", show: "show", customize: "customize", sortable: "sortable", direction: "direction", align: "align", width: "width", className: ["class", "className"] }, queries: [{ propertyName: "headerTemplate", first: true, predicate: FsGalleryListHeaderDirective, descendants: true, read: TemplateRef, static: true }, { propertyName: "headerConfigs", first: true, predicate: FsGalleryListHeaderDirective, descendants: true, static: true }, { propertyName: "cellTemplate", first: true, predicate: FsGalleryListCellDirective, descendants: true, read: TemplateRef, static: true }, { propertyName: "cellConfigs", first: true, predicate: FsGalleryListCellDirective, descendants: true, static: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryListColumnDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'fs-gallery-list-column',
                }]
        }], propDecorators: { title: [{
                type: Input
            }], name: [{
                type: Input
            }], show: [{
                type: Input
            }], customize: [{
                type: Input
            }], sortable: [{
                type: Input
            }], direction: [{
                type: Input
            }], align: [{
                type: Input
            }], width: [{
                type: Input
            }], className: [{
                type: Input,
                args: ['class']
            }], headerTemplate: [{
                type: ContentChild,
                args: [FsGalleryListHeaderDirective, { read: TemplateRef, static: true }]
            }], headerConfigs: [{
                type: ContentChild,
                args: [FsGalleryListHeaderDirective, { static: true }]
            }], cellTemplate: [{
                type: ContentChild,
                args: [FsGalleryListCellDirective, { read: TemplateRef, static: true }]
            }], cellConfigs: [{
                type: ContentChild,
                args: [FsGalleryListCellDirective, { static: true }]
            }] } });

class FsGalleryEmptyStateDirective {
}
FsGalleryEmptyStateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryEmptyStateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsGalleryEmptyStateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryEmptyStateDirective, selector: "[fsGalleryEmptyState]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryEmptyStateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsGalleryEmptyState]',
                }]
        }] });

class FsGalleryNavComponent {
    constructor(galleryService, _cdRef) {
        this.galleryService = galleryService;
        this._cdRef = _cdRef;
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        this.galleryService.data$
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            this._cdRef.markForCheck();
        });
    }
    navClick(item) {
        const index = this.galleryService.navItems.indexOf(item);
        this.galleryService.navItems = index === -1 ? [] : this.galleryService.navItems.splice(index);
        this.galleryService.loadGallery();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
FsGalleryNavComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryNavComponent, deps: [{ token: FsGalleryService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsGalleryNavComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryNavComponent, selector: "fs-gallery-nav", ngImport: i0, template: "<ng-container *ngIf=\"galleryService.navItems.length\">\n  <div class=\"nav\">\n    <a \n        mat-icon-button  \n        color=\"primary\"  \n        (click)=\"navClick(null)\">\n      <mat-icon>home</mat-icon>\n    </a>\n    <ng-container *ngFor=\"let item of galleryService.navItems\">\n      <mat-icon class=\"chevron\">chevron_right</mat-icon>\n      <a \n          class=\"name\"\n          (click)=\"navClick(item)\">\n        {{item.name}}\n      </a>\n    </ng-container>\n  </div>\n</ng-container>\n", styles: [".nav{display:flex;align-items:center;color:#717171;margin-bottom:2px;-webkit-user-select:none;user-select:none}.nav mat-icon{margin:0 5px}.nav a.name{color:inherit}\n"], components: [{ type: i1$6.MatAnchor, selector: "a[mat-button], a[mat-raised-button], a[mat-icon-button], a[mat-fab],             a[mat-mini-fab], a[mat-stroked-button], a[mat-flat-button]", inputs: ["disabled", "disableRipple", "color", "tabIndex"], exportAs: ["matButton", "matAnchor"] }, { type: i2$3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryNavComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-nav',
                    templateUrl: './gallery-nav.component.html',
                    styleUrls: ['./gallery-nav.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: FsGalleryService }, { type: i0.ChangeDetectorRef }]; } });

class FsGalleryListViewComponent {
    constructor(_galleryService) {
        this._galleryService = _galleryService;
        this.MimeType = MimeType;
        this.GalleryView = GalleryView;
        this.openPreview = (item) => {
            this._galleryService.openPreview(item);
        };
        this.listConfig = this._galleryService.listConfig;
    }
    get emptyStateTemplate() {
        return this._galleryService.emptyStateTemplate;
    }
    ngAfterViewInit() {
        this._galleryService.setLister(this.listRef);
    }
}
FsGalleryListViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryListViewComponent, deps: [{ token: FsGalleryService }], target: i0.ɵɵFactoryTarget.Component });
FsGalleryListViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryListViewComponent, selector: "fs-gallery-list-view", inputs: { galleryConfig: "galleryConfig", imageWidth: "imageWidth" }, viewQueries: [{ propertyName: "listRef", first: true, predicate: FsListComponent, descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"listConfig\">\n  <fs-list\n      [config]=\"listConfig\"\n      [ngClass]=\"{ 'grid-mode': (galleryConfig.viewMode$ | async) === GalleryView.Gallery }\"\n      #list>\n    <fs-list-column width=\"1%\">\n      <ng-template fs-list-cell let-row=\"row\">\n        <div class=\"icon\">\n          <ng-container *ngIf=\"row.mime.type === MimeType.Image else icon\">\n            <img [src]=\"row.preview\" alt=\"\" [style.width]=\"'100px'\">\n          </ng-container>\n          <ng-template #icon>\n            <fs-gallery-file-icon\n              [item]=\"row\"\n              [width]=\"50\">\n            </fs-gallery-file-icon>\n          </ng-template>\n        </div>\n      </ng-template>\n    </fs-list-column>\n\n    <ng-container *ngFor=\"let col of galleryConfig.listColumns$ | async\">\n      <fs-list-column\n          [align]=\"col.align\"\n          [class]=\"col.className\"\n          [customize]=\"col.customize\"\n          [direction]=\"col.direction\"\n          [name]=\"col.name\"\n          [show]=\"col.show\"\n          [sortable]=\"col.sortable\"\n          [title]=\"col.title\"\n          [width]=\"col.width\">\n        <ng-container *ngIf=\"col.headerTemplate\">\n          <ng-template fs-list-header\n              let-row=\"row\"\n              [align]=\"col.headerConfigs?.align\"\n              [class]=\"col.headerConfigs?.styleClass\"\n              [colspan]=\"col.headerConfigs?.colspan\">\n            <ng-container\n              *ngTemplateOutlet=\"col.headerTemplate; context: { $implicit: row, row: row }\">\n            </ng-container>\n          </ng-template>\n        </ng-container>\n        <ng-template fs-list-cell\n            let-row=\"row\"\n            [align]=\"col.cellConfigs.align\"\n            [class]=\"col.cellConfigs.styleClass\"\n            [colspan]=\"col.cellConfigs.colspan\">\n          <ng-container\n            *ngTemplateOutlet=\"col.cellTemplate;\n            context: { $implicit: row, row: row, openPreview: openPreview }\">\n          </ng-container>\n        </ng-template>\n      </fs-list-column>\n    </ng-container>\n\n    <ng-template fs-list-empty-state>\n      <div class=\"fs-gallery-no-results\">\n        <ng-template [ngTemplateOutlet]=\"emptyStateTemplate\"></ng-template>\n      </div>\n    </ng-template>\n  </fs-list>\n</ng-container>\n", styles: [":host ::ng-deep .grid-mode{display:none}:host ::ng-deep .fs-list-header-container{margin-bottom:15px}:host ::ng-deep .fs-list-col-selection{width:1%}.icon img{border-radius:5px}.icon fs-gallery-file-icon{display:flex;justify-content:center}.name{cursor:pointer}\n"], components: [{ type: i2$4.FsListComponent, selector: "fs-list", inputs: ["config", "loaderLines"], outputs: ["filtersReady"] }, { type: FsGalleryFileIconComponent, selector: "fs-gallery-file-icon", inputs: ["item", "width", "height"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2$4.FsListColumnDirective, selector: "fs-list-column", inputs: ["show", "title", "name", "customize", "sortable", "sortableDefault", "direction", "align", "width", "class"] }, { type: i2$4.FsListCellDirective, selector: "[fs-list-cell]", inputs: ["colspan", "align", "class"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$4.FsListHeaderDirective, selector: "[fs-list-header]", inputs: ["colspan", "align", "class"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2$4.FsListEmptyStateDirective, selector: "[fs-list-empty-state]" }], pipes: { "async": i2.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryListViewComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-list-view',
                    templateUrl: './list-view.component.html',
                    styleUrls: ['./list-view.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: FsGalleryService }]; }, propDecorators: { listRef: [{
                type: ViewChild,
                args: [FsListComponent]
            }], galleryConfig: [{
                type: Input
            }], imageWidth: [{
                type: Input
            }] } });

class FsGalleryViewComponent {
    constructor(galleryService) {
        this.galleryService = galleryService;
        this.orderChange = new EventEmitter();
    }
}
FsGalleryViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryViewComponent, deps: [{ token: FsGalleryService }], target: i0.ɵɵFactoryTarget.Component });
FsGalleryViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryViewComponent, selector: "fs-gallery-gallery-view", inputs: { data$: "data$", reorderEnabled: "reorderEnabled", galleryConfig: "galleryConfig" }, outputs: { orderChange: "orderChange" }, ngImport: i0, template: "<div\n    *ngIf=\"reorderEnabled\"\n    [class]=\"'fs-gallery-thumbnails zoom-size-' + galleryService.imageZoomInteger + ' layout-' + galleryService.config.layout\"\n    [dragula]=\"galleryService.dragName\"\n    [dragulaModel]=\"data$ | async\"\n    (dragulaModelChange)=\"orderChange.emit($event)\">\n  <ng-container *ngTemplateOutlet=\"thumbnailsTemplate\"></ng-container>\n</div>\n\n<div\n    *ngIf=\"!reorderEnabled && (data$ | async).length\"\n    [class]=\"'fs-gallery-thumbnails zoom-size-' + galleryService.imageZoomInteger + ' layout-' + galleryService.config.layout\">\n  <ng-container *ngTemplateOutlet=\"thumbnailsTemplate\"></ng-container>\n</div>\n\n<ng-template #thumbnailsTemplate>\n  <fs-gallery-thumbnail\n    *ngFor=\"let item of data$ | async; let index = index; let first = first; let last = last\"\n    #fsGalleryThumbnail\n    [index]=\"index\"\n    [first]=\"first\"\n    [last]=\"last\"\n    [item]=\"item\">\n  </fs-gallery-thumbnail>\n</ng-template>\n\n<div\n    *ngIf=\"!(data$ | async).length\"\n    class=\"fs-gallery-no-results\">\n  <ng-container *ngIf=\"galleryService.emptyStateEnabled else notFound\">\n    <ng-template [ngTemplateOutlet]=\"galleryService.emptyStateTemplate\"></ng-template>\n  </ng-container>\n  <ng-template #notFound>\n    No Results Found\n  </ng-template>\n</div>\n", styles: [".fs-gallery-preview-open{overflow:hidden}.fs-gallery-no-results{text-align:center;color:#999;padding:10px 0}:host{display:block}.fs-gallery-thumbnails.layout-flow,.fs-gallery-thumbnails.layout-flow-nowrap{display:flex;flex-direction:row;flex-wrap:wrap;margin-top:-10px}.fs-gallery-thumbnails.layout-flow.layout-flow-nowrap,.fs-gallery-thumbnails.layout-flow-nowrap.layout-flow-nowrap{flex-wrap:nowrap}.fs-gallery-thumbnails.layout-flow ::ng-deep fs-gallery-thumbnail .fs-gallery-thumbnail,.fs-gallery-thumbnails.layout-flow-nowrap ::ng-deep fs-gallery-thumbnail .fs-gallery-thumbnail{margin-right:10px;margin-top:10px}.fs-gallery-thumbnails.layout-flow ::ng-deep fs-gallery-thumbnail:last-child .fs-gallery-thumbnail,.fs-gallery-thumbnails.layout-flow-nowrap ::ng-deep fs-gallery-thumbnail:last-child .fs-gallery-thumbnail{margin-right:0}.fs-gallery-thumbnails.layout-grid{display:grid;grid-gap:10px;width:100%;min-width:0;table-layout:fixed;grid-template-columns:repeat(7,minmax(0,1fr))}.fs-gallery-thumbnails.layout-grid.zoom-size-3{grid-template-columns:repeat(2,minmax(0,1fr))}.fs-gallery-thumbnails.layout-grid.zoom-size-2{grid-template-columns:repeat(3,minmax(0,1fr))}.fs-gallery-thumbnails.layout-grid.zoom-size-1{grid-template-columns:repeat(4,minmax(0,1fr))}.fs-gallery-thumbnails.layout-grid.zoom-size-0{grid-template-columns:repeat(7,minmax(0,1fr))}@media (max-width: 1000px){.fs-gallery-thumbnails.layout-grid{grid-template-columns:repeat(4,minmax(0,1fr))}.fs-gallery-thumbnails.layout-grid.zoom-size-3{grid-template-columns:repeat(1,minmax(0,1fr))}.fs-gallery-thumbnails.layout-grid.zoom-size-2{grid-template-columns:repeat(2,minmax(0,1fr))}.fs-gallery-thumbnails.layout-grid.zoom-size-1{grid-template-columns:repeat(3,minmax(0,1fr))}.fs-gallery-thumbnails.layout-grid.zoom-size-0{grid-template-columns:repeat(4,minmax(0,1fr))}}@media (max-width: 599px){.fs-gallery-thumbnails.layout-grid{grid-template-columns:repeat(2,minmax(0,1fr))}.fs-gallery-thumbnails.layout-grid.zoom-size-3,.fs-gallery-thumbnails.layout-grid.zoom-size-2,.fs-gallery-thumbnails.layout-grid.zoom-size-1,.fs-gallery-thumbnails.layout-grid.zoom-size-0{grid-template-columns:repeat(2,minmax(0,1fr))}}.no-results{text-align:center;color:#999;padding:10px 0}\n"], components: [{ type: FsGalleryThumbnailComponent, selector: "fs-gallery-thumbnail", inputs: ["item", "index", "first", "last"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.DragulaDirective, selector: "[dragula]", inputs: ["dragula", "dragulaModel"], outputs: ["dragulaModelChange"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i2.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryViewComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery-gallery-view',
                    templateUrl: './gallery-view.component.html',
                    styleUrls: ['./gallery-view.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: FsGalleryService }]; }, propDecorators: { data$: [{
                type: Input
            }], reorderEnabled: [{
                type: Input
            }], galleryConfig: [{
                type: Input
            }], orderChange: [{
                type: Output
            }] } });

class FsGalleryComponent {
    constructor(galleryService) {
        this.galleryService = galleryService;
        this.zoomChanged = new EventEmitter();
        this.previewTemplate = null;
        this.navTemplate = null;
        this.thumbnailTemplate = null;
        this.thumbnailPreviewTemplate = null;
        this.emptyStateTemplate = null;
        this.reorderEnabled = true;
        this.GalleryView = GalleryView;
        this._config = null;
        this._destroy$ = new Subject();
    }
    set config(config) {
        this.galleryService.config = config;
        this._config = this.galleryService.config;
    }
    ngOnInit() {
        this.galleryService.setFilter(this.filter);
        this.data$ = this.galleryService.data$;
        this.reorderEnabled = this.galleryService.config.reorderable;
    }
    navClick(item) {
        const index = this.galleryService.navItems.indexOf(item);
        this.galleryService.navItems = index === -1 ? [] : this.galleryService.navItems.splice(index);
        this.galleryService.loadGallery();
    }
    ngAfterContentInit() {
        this.galleryService.previewTemplate = this.previewTemplate;
        this.galleryService.thumbnailTemplate = this.thumbnailTemplate;
        this.galleryService.previewDetails = this.previewDetails;
        this.galleryService.thumbnailPreviewTemplate = this.thumbnailPreviewTemplate;
        this.galleryService.emptyStateTemplate = this.emptyStateTemplate;
        this.galleryService.setListColumns(this._listColumnDirectives.toArray());
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    orderChange(value) {
        this.data$.next(value);
        if (this._config.reorderEnd) {
            this._config.reorderEnd(value);
        }
    }
    get hasFilter() {
        if (!this.galleryService.filterConfig) {
            return false;
        }
        const actions = this.galleryService.filterConfig.actions
            .some((action) => {
            return !action.show || action.show();
        });
        const items = this.galleryService.filterConfig.items
            .some((item) => {
            return !item.hide;
        });
        return actions || items;
    }
    isReorderEnabled() {
        return this.reorderEnabled;
    }
    enableReorder() {
        if (this.galleryService.config.reorderable) {
            this.reorderEnabled = true;
        }
    }
    disableReorder() {
        this.reorderEnabled = false;
    }
    reload() {
        this.galleryService.reload();
    }
    filterReady() {
        this.galleryService.filtersReady$.next();
    }
}
FsGalleryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryComponent, deps: [{ token: FsGalleryService }], target: i0.ɵɵFactoryTarget.Component });
FsGalleryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsGalleryComponent, selector: "fs-gallery", inputs: { config: "config" }, outputs: { zoomChanged: "zoomChanged" }, providers: [
        FsGalleryService,
        PersistanceController,
        {
            provide: GalleryPreviewComponentInjector,
            useValue: FsGalleryPreviewComponent
        },
    ], queries: [{ propertyName: "previewTemplate", first: true, predicate: FsGalleryPreviewDirective, descendants: true, read: TemplateRef }, { propertyName: "navTemplate", first: true, predicate: FsGalleryNavDirective, descendants: true, read: TemplateRef }, { propertyName: "previewDetails", first: true, predicate: FsGalleryPreviewDetailsDirective, descendants: true }, { propertyName: "thumbnailTemplate", first: true, predicate: FsGalleryThumbnailDirective, descendants: true, read: TemplateRef }, { propertyName: "thumbnailPreviewTemplate", first: true, predicate: FsGalleryThumbnailPreviewDirective, descendants: true, read: TemplateRef }, { propertyName: "emptyStateTemplate", first: true, predicate: FsGalleryEmptyStateDirective, descendants: true, read: TemplateRef }, { propertyName: "_listColumnDirectives", predicate: FsGalleryListColumnDirective }], viewQueries: [{ propertyName: "filter", first: true, predicate: FilterComponent, descendants: true, static: true }], ngImport: i0, template: "<fs-filter\n  [ngClass]=\"{ 'has-filter': hasFilter }\"\n  [config]=\"galleryService.filterConfig\"\n  (ready)=\"filterReady()\">\n</fs-filter>\n\n<ng-container *ngIf=\"navTemplate; else nav\">\n  <ng-template [ngTemplateOutlet]=\"navTemplate\" [ngTemplateOutletContext]=\"{ template: nav }\"></ng-template>\n</ng-container>\n\n<ng-template #nav>\n  <fs-gallery-nav></fs-gallery-nav>\n</ng-template>\n\n<fs-gallery-list-view\n  *ngIf=\"(galleryService.config.viewMode$ | async) === GalleryView.List\"\n  [imageWidth]=\"galleryService.imageWidth\"\n  [galleryConfig]=\"galleryService.config\">\n</fs-gallery-list-view>\n\n<fs-gallery-gallery-view\n  *ngIf=\"(galleryService.config.viewMode$ | async) === GalleryView.Gallery\"\n  [reorderEnabled]=\"reorderEnabled\"\n  [data$]=\"data$\"\n  (orderChange)=\"orderChange($event)\">\n</fs-gallery-gallery-view>\n", styles: [":host ::ng-deep .fs-filter{margin-bottom:10px;display:none}:host ::ng-deep .fs-filter fs-filter-action-button button.size,:host ::ng-deep .fs-filter fs-filter-action-button .view-mode{min-width:36px;padding:0}.has-filter{display:block}\n"], components: [{ type: i2$5.FilterComponent, selector: "fs-filter", inputs: ["config", "filter", "showSortBy", "showFilterInput"], outputs: ["closed", "opened", "ready"] }, { type: FsGalleryNavComponent, selector: "fs-gallery-nav" }, { type: FsGalleryListViewComponent, selector: "fs-gallery-list-view", inputs: ["galleryConfig", "imageWidth"] }, { type: FsGalleryViewComponent, selector: "fs-gallery-gallery-view", inputs: ["data$", "reorderEnabled", "galleryConfig"], outputs: ["orderChange"] }], directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "async": i2.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-gallery',
                    templateUrl: './gallery.component.html',
                    styleUrls: ['./gallery.component.scss'],
                    providers: [
                        FsGalleryService,
                        PersistanceController,
                        {
                            provide: GalleryPreviewComponentInjector,
                            useValue: FsGalleryPreviewComponent
                        },
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: FsGalleryService }]; }, propDecorators: { zoomChanged: [{
                type: Output
            }], config: [{
                type: Input
            }], previewTemplate: [{
                type: ContentChild,
                args: [FsGalleryPreviewDirective, { read: TemplateRef }]
            }], navTemplate: [{
                type: ContentChild,
                args: [FsGalleryNavDirective, { read: TemplateRef }]
            }], previewDetails: [{
                type: ContentChild,
                args: [FsGalleryPreviewDetailsDirective]
            }], thumbnailTemplate: [{
                type: ContentChild,
                args: [FsGalleryThumbnailDirective, { read: TemplateRef }]
            }], thumbnailPreviewTemplate: [{
                type: ContentChild,
                args: [FsGalleryThumbnailPreviewDirective, { read: TemplateRef }]
            }], emptyStateTemplate: [{
                type: ContentChild,
                args: [FsGalleryEmptyStateDirective, { read: TemplateRef }]
            }], filter: [{
                type: ViewChild,
                args: [FilterComponent, { static: true }]
            }], _listColumnDirectives: [{
                type: ContentChildren,
                args: [FsGalleryListColumnDirective]
            }] } });

class HammerConfig extends HammerGestureConfig {
    constructor() {
        super(...arguments);
        this.overrides = {
            swipe: { velocity: 0.4, threshold: 20 }
        };
    }
}
HammerConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: HammerConfig, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
HammerConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: HammerConfig });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: HammerConfig, decorators: [{
            type: Injectable
        }] });

class FsGalleryModule {
    static forRoot() {
        return {
            ngModule: FsGalleryModule,
            providers: [
                {
                    provide: HAMMER_GESTURE_CONFIG,
                    useClass: HammerConfig
                }
            ]
        };
    }
}
FsGalleryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsGalleryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryModule, declarations: [FsGalleryComponent,
        FsGalleryThumbnailComponent,
        FsGalleryPreviewComponent,
        FsGalleryPreviewHeaderComponent,
        FsGalleryPreviewCarouselComponent,
        FsGalleryThumbnailInfoComponent,
        FsGalleryThumbnailDirective,
        FsGalleryPreviewDirective,
        FsGalleryThumbnailPreviewDirective,
        FsGalleryFileIconComponent,
        FsGalleryThumbnailPreviewComponent,
        FsGalleryListViewComponent,
        FsGalleryListColumnDirective,
        FsGalleryListCellDirective,
        FsGalleryListHeaderDirective,
        FsGalleryViewComponent,
        FsGalleryIconComponent,
        FsGalleryPreviewDetailsComponent,
        FsGalleryPreviewDetailsDirective,
        FsGalleryFolderIconInfoComponent,
        FsGalleryNavComponent,
        FsGalleryNavDirective,
        FsGalleryEmptyStateDirective,
        FsGalleryMenuComponent,
        ImageSrcPipe], imports: [CommonModule,
        MatIconModule,
        MatSliderModule,
        MatButtonModule,
        MatDialogModule,
        MatTooltipModule,
        MatSidenavModule,
        FsFilterModule,
        FsFileModule,
        FsListModule,
        FsMenuModule,
        FsLabelModule,
        FsPdfViewerModule,
        OverlayModule,
        DragulaModule], exports: [FsGalleryComponent,
        FsGalleryThumbnailInfoComponent,
        FsGalleryThumbnailDirective,
        FsGalleryPreviewDirective,
        FsGalleryThumbnailPreviewDirective,
        FsGalleryThumbnailPreviewComponent,
        FsGalleryListColumnDirective,
        FsGalleryListCellDirective,
        FsGalleryListHeaderDirective,
        FsGalleryIconComponent,
        FsGalleryFileIconComponent,
        FsGalleryPreviewDetailsDirective,
        FsGalleryNavComponent,
        FsGalleryNavDirective,
        FsGalleryEmptyStateDirective] });
FsGalleryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryModule, imports: [[
            CommonModule,
            MatIconModule,
            MatSliderModule,
            MatButtonModule,
            MatDialogModule,
            MatTooltipModule,
            MatSidenavModule,
            FsFilterModule,
            FsFileModule,
            FsListModule,
            FsMenuModule,
            FsLabelModule,
            FsPdfViewerModule,
            OverlayModule,
            DragulaModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGalleryModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatSliderModule,
                        MatButtonModule,
                        MatDialogModule,
                        MatTooltipModule,
                        MatSidenavModule,
                        FsFilterModule,
                        FsFileModule,
                        FsListModule,
                        FsMenuModule,
                        FsLabelModule,
                        FsPdfViewerModule,
                        OverlayModule,
                        DragulaModule,
                    ],
                    declarations: [
                        FsGalleryComponent,
                        FsGalleryThumbnailComponent,
                        FsGalleryPreviewComponent,
                        FsGalleryPreviewHeaderComponent,
                        FsGalleryPreviewCarouselComponent,
                        FsGalleryThumbnailInfoComponent,
                        FsGalleryThumbnailDirective,
                        FsGalleryPreviewDirective,
                        FsGalleryThumbnailPreviewDirective,
                        FsGalleryFileIconComponent,
                        FsGalleryThumbnailPreviewComponent,
                        FsGalleryListViewComponent,
                        FsGalleryListColumnDirective,
                        FsGalleryListCellDirective,
                        FsGalleryListHeaderDirective,
                        FsGalleryViewComponent,
                        FsGalleryIconComponent,
                        FsGalleryPreviewDetailsComponent,
                        FsGalleryPreviewDetailsDirective,
                        FsGalleryFolderIconInfoComponent,
                        FsGalleryNavComponent,
                        FsGalleryNavDirective,
                        FsGalleryEmptyStateDirective,
                        FsGalleryMenuComponent,
                        ImageSrcPipe,
                    ],
                    exports: [
                        FsGalleryComponent,
                        FsGalleryThumbnailInfoComponent,
                        FsGalleryThumbnailDirective,
                        FsGalleryPreviewDirective,
                        FsGalleryThumbnailPreviewDirective,
                        FsGalleryThumbnailPreviewComponent,
                        FsGalleryListColumnDirective,
                        FsGalleryListCellDirective,
                        FsGalleryListHeaderDirective,
                        FsGalleryIconComponent,
                        FsGalleryFileIconComponent,
                        FsGalleryPreviewDetailsDirective,
                        FsGalleryNavComponent,
                        FsGalleryNavDirective,
                        FsGalleryEmptyStateDirective,
                    ],
                }]
        }] });

class FsGallery {
    constructor(_injector, _overlay, _location, _dragulaService, _store, _route) {
        this._injector = _injector;
        this._overlay = _overlay;
        this._location = _location;
        this._dragulaService = _dragulaService;
        this._store = _store;
        this._route = _route;
    }
    openPreview(item, options) {
        this.openPreviews([item], options);
    }
    openPreviews(items, options) {
        const persistanceController = new PersistanceController(this._store, this._route);
        const galleryService = new FsGalleryService(FsGalleryPreviewComponent, this._overlay, this._injector, this._location, this._dragulaService, persistanceController);
        galleryService.data = items;
        galleryService.previewDetails = options === null || options === void 0 ? void 0 : options.previewDetails;
        if (options === null || options === void 0 ? void 0 : options.config) {
            galleryService.config = options.config;
        }
        galleryService.openPreview(galleryService.data[0])
            .onClose
            .pipe(take(1))
            .subscribe(() => {
        });
    }
}
FsGallery.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGallery, deps: [{ token: i0.Injector }, { token: i1$3.Overlay }, { token: i2.Location }, { token: i3.DragulaService }, { token: i1$2.FsStore }, { token: i2$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Injectable });
FsGallery.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGallery, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsGallery, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i1$3.Overlay }, { type: i2.Location }, { type: i3.DragulaService }, { type: i1$2.FsStore }, { type: i2$1.ActivatedRoute }]; } });

// Hack
window.global = window;

/**
 * Generated bundle index. Do not edit.
 */

export { FsGallery, FsGalleryComponent, FsGalleryEmptyStateDirective, FsGalleryFileIconComponent, FsGalleryIconComponent, FsGalleryListCellDirective, FsGalleryListColumnDirective, FsGalleryListHeaderDirective, FsGalleryModule, FsGalleryNavComponent, FsGalleryNavDirective, FsGalleryPreviewCarouselComponent, FsGalleryPreviewComponent, FsGalleryPreviewDetailsDirective, FsGalleryPreviewDirective, FsGalleryPreviewHeaderComponent, FsGalleryThumbnailComponent, FsGalleryThumbnailDirective, FsGalleryThumbnailInfoComponent, FsGalleryThumbnailPreviewComponent, FsGalleryThumbnailPreviewDirective, GalleryLayout, GalleryThumbnailSize, MimeType, ThumbnailScale, mime, mimeColor, processMenuItems };
